import {
  CalendarDays,
  LayoutDashboard,
  ShoppingCart,
  Target,
  UserCog,
  type LucideIcon,
} from "lucide-react";
import { TOUR_SHOTS_VERSION } from "./tourShotsVersion";

/** The five product-tour captures. Assets are produced by
 * `npm run screenshots:landing` (scripts/capture_landing_screenshots.mjs) from
 * the showcase tenants — EN shots from Cedar & Oak Home Goods, ES shots from
 * Ferretería Progreso — in every language × theme variant. */
export type TourShotKey = "overview" | "team" | "sales" | "calendar" | "goals";
export type TourLang = "en" | "es";
export type TourTheme = "light" | "dark";

/** Native pixel size of the 1x capture (1440×900 viewport downscaled to
 * 1280w). Rendered inside an aspect-[16/10] box so layout never shifts. */
export const TOUR_SHOT_WIDTH = 1280;
export const TOUR_SHOT_HEIGHT = 800;

// Icons mirror AppLayout's nav so the tabs read like the app itself.
export const TOUR_SHOTS: { key: TourShotKey; icon: LucideIcon }[] = [
  { key: "overview", icon: LayoutDashboard },
  { key: "team", icon: UserCog },
  { key: "sales", icon: ShoppingCart },
  { key: "calendar", icon: CalendarDays },
  { key: "goals", icon: Target },
];

export function tourShotSrc(
  key: TourShotKey,
  lang: TourLang,
  theme: TourTheme,
  retina = false,
): string {
  // ?v= busts browser caches when captures change: these files keep stable
  // names through the Vite build and are served with a 1-year max-age.
  return `/screenshots/${key}.${lang}.${theme}${retina ? "@2x" : ""}.webp?v=${TOUR_SHOTS_VERSION}`;
}

/** srcSet pairing the 1x and @2x variants of a capture. */
export function tourShotSrcSet(key: TourShotKey, lang: TourLang, theme: TourTheme): string {
  return `${tourShotSrc(key, lang, theme)} 1x, ${tourShotSrc(key, lang, theme, true)} 2x`;
}
